import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacFinderService } from '../fac-finder.service';
import { XFacContactAddModel } from 'src/app/shared/models/xfac-contact.model';
import { XFacContactResponse, XFacAddressResponse, XFacDependentResponse } from 'src/app/shared/models/response.model';
import { XFacAddressAddModel } from 'src/app/shared/models/xfac-address.model';
import { XFacDependentAddModel } from 'src/app/shared/models/xfac-dependent.model';

@Component({
  selector: 'app-add-dependant',
  templateUrl: './add-dependant.component.html',
  styleUrls: ['./add-dependant.component.css']
})
export class AddDependantComponent implements OnInit {

  title;
  data;
  errors;
  addDependantForm: FormGroup;
  dependantAddModel : XFacDependentAddModel;
  submitted = false;
  event: EventEmitter<any> = new EventEmitter();
  Isvalid:boolean;
  business_id : string;
  buttonText: string ="Add New Contact Details";
  dependantGenderList : any = [];
  facFinderId : any;
  clientCode : any;

  constructor(
    private ngxService: NgxUiLoaderService,
    private formBuilder: FormBuilder,
    private router: Router, 
    private facFinderService: FacFinderService,
    public modalRef: BsModalRef,
    private toastr: ToastrService
    ) { }
 
  ngOnInit() {
    this.Isvalid = true;    
    this.dependantAddModel = new XFacDependentAddModel(); 
    this.dependantAddModel.gender ="000"; 

    if(this.data.dependant !=null){
      //console.log(this.data.library);
      this.buttonText = "Update Now";
      Object.assign(this.dependantAddModel, this.data.dependant);
      this.dependantAddModel.dateOfBirth = new Date(this.dependantAddModel.dateOfBirth);
    }
    
    if(this.data.dependant_gender_list !=null){
      Object.assign(this.dependantGenderList, this.data.dependant_gender_list);
    }

    this.dependantGenderList.sort((a,b) => b.key - a.key);

    if(this.data.facFinderId !=null){
      this.facFinderId = this.data.facFinderId;
    }

    if(this.data.clientCode !=null){
      this.clientCode = this.data.clientCode;
    }

    this.title = this.data.title;

    // if(this.data.business_id !=null){
    //   this.business_id = this.data.business_id;
    // }

    this.addDependantForm = this.formBuilder.group({
      dateOfBirth: ['', Validators.required],
      firstName: ['', Validators.required],
      surname: ['', Validators.required],
      gender: ['', Validators.required],
      //state: ['', Validators.required],
    });

  }

  get f() { return this.addDependantForm.controls; }

onSubmit(){
 this.submitted = true;

 let gender = this.dependantAddModel.gender;

 if (this.addDependantForm.invalid || (gender && gender.trim()=="000") ) { //|| (title && title.trim()=="")

  if(gender && gender.trim()=="000"){
    this.addDependantForm.controls['gender'].setErrors({'required': true});
  }
  // console.log(this.f);
  // console.log(this.addDependantForm.invalid);
  return;
}

else{
  //this.folderModel.name = title.trim();

if(this.data.dependant !=null){
//   this.ngxService.start();
// //console.log("Edditre");

  this.ngxService.start();
  this.dependantAddModel.clientCode = this.clientCode;
  // this.dependantAddModel.dependantUntilAge = 0;
  // this.dependantAddModel.financiallyDependent = false;
  this.facFinderService.editDependant(this.dependantAddModel, this.facFinderId)
  .subscribe((data:XFacDependentResponse)=>{
  this.ngxService.stop();
  if(data.error && !data.success){      
    this.toastr.error('Error on updating dependant.');      
  }
  else{
    this.toastr.success('Dependant updated successfully.');
    this.event.emit('OK');
   // console.log(this.event);
    this.modalRef.hide();
  }
  
  },err=>{   
    console.log(err);
    this.ngxService.stop();
    this.toastr.error('Error on updating dependant.');
  });
    
    //this.router.navigate(['agents']);
    

}else{
  
  this.ngxService.start();
  this.dependantAddModel.clientCode = this.clientCode;
  this.facFinderService.addDependant(this.dependantAddModel, this.facFinderId)
  .subscribe((data:XFacDependentResponse)=>{
    this.ngxService.stop();
    if(data.error && !data.success){      
      this.toastr.error('Error on saving dependant.');      
    }
    else{
      this.toastr.success('Dependant added successfully.');
      this.event.emit('OK');
     // console.log(this.event);
      this.modalRef.hide();
    }
    
    },err=>{   
      console.log(err);
      this.ngxService.stop();
      this.toastr.error('Error on saving dependant.');
    });

  }

}

}

modalRehide(){
  if (!this.modalRef) {
    return;
  } 
  this.modalRef.hide();
  this.modalRef = null;
}

ClosePopup(){
  this.modalRef.hide();
}

onReset() {
  this.submitted = false;
  this.addDependantForm.reset();
}

}
